export default {
  methods: {
    hasPlatform (refPlatform) {
      return this.app.apps.find(({ platform }) => platform === refPlatform)
    }
  }
}
